export default __webpack_public_path__ + "static/media/GuidelinesAR.d29c3bd6.pdf";